var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stars_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m6.5 13 .784 1.57c.266.53.399.796.576 1.026a3 3 0 0 0 .545.544c.23.178.495.31 1.026.576L11 17.5l-1.569.785c-.53.265-.796.398-1.026.575a3 3 0 0 0-.545.545c-.177.23-.31.495-.576 1.026l-.784 1.57-.784-1.57c-.266-.53-.399-.796-.576-1.026a3 3 0 0 0-.545-.545c-.23-.177-.495-.31-1.026-.575L2 17.5l1.569-.784c.53-.266.796-.398 1.026-.576a3 3 0 0 0 .545-.544c.177-.23.31-.496.576-1.027z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stars_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15 2 1.179 3.065c.282.733.423 1.1.642 1.408a3 3 0 0 0 .706.706c.309.22.675.36 1.409.643L22 9l-3.064 1.179c-.734.282-1.1.423-1.409.642a3 3 0 0 0-.706.707c-.22.308-.36.675-.642 1.408L15 16l-1.179-3.064c-.282-.733-.423-1.1-.642-1.408a3 3 0 0 0-.706-.707c-.309-.22-.675-.36-1.409-.642L8 9l3.064-1.178c.734-.282 1.1-.423 1.409-.643a3 3 0 0 0 .706-.706c.22-.308.36-.675.642-1.408z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__a",
    x1: 20.226,
    x2: -19.745,
    y1: 2.552,
    y2: 17.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__b",
    x1: 20.226,
    x2: -19.745,
    y1: 2.552,
    y2: 17.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgStars;